var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconQuestionCircleComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-question-circle ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_53536d7504__clip0_2738_72973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 1.99984C4.68637 1.99984 2.00008 4.68613 2.00008 7.99984C2.00008 11.3135 4.68637 13.9998 8.00008 13.9998C11.3138 13.9998 14.0001 11.3135 14.0001 7.99984C14.0001 4.68613 11.3138 1.99984 8.00008 1.99984ZM0.666748 7.99984C0.666748 3.94975 3.94999 0.666504 8.00008 0.666504C12.0502 0.666504 15.3334 3.94975 15.3334 7.99984C15.3334 12.0499 12.0502 15.3332 8.00008 15.3332C3.94999 15.3332 0.666748 12.0499 0.666748 7.99984ZM8.03038 4.99984C7.39074 4.99984 6.78118 5.40957 6.42064 6.20316C6.34449 6.37077 6.15762 6.46649 5.98298 6.40828L5.35052 6.19746C5.17587 6.13924 5.08027 5.94975 5.15149 5.77999C5.66011 4.56755 6.68613 3.6665 8.03038 3.6665C9.48641 3.6665 10.6667 4.84684 10.6667 6.30287C10.6667 7.07111 10.2629 7.82003 9.73897 8.35782C9.27199 8.83719 8.527 9.23384 7.66635 9.31709C7.48311 9.33481 7.33345 9.18393 7.33345 8.99984V8.33317C7.33345 8.14908 7.48356 8.00173 7.66525 7.97208C8.07663 7.90495 8.50121 7.71762 8.78391 7.42742C9.14637 7.05536 9.33341 6.62246 9.33341 6.30287C9.33341 5.58322 8.75003 4.99984 8.03038 4.99984ZM8.00008 11.9998C7.4478 11.9998 7.00008 11.5521 7.00008 10.9998C7.00008 10.4476 7.4478 9.99984 8.00008 9.99984C8.55237 9.99984 9.00008 10.4476 9.00008 10.9998C9.00008 11.5521 8.55237 11.9998 8.00008 11.9998Z",
    fillOpacity: "1"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_53536d7504__clip0_2738_72973"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  }))));
}
var IconQuestionCircle = /*#__PURE__*/React.forwardRef(IconQuestionCircleComponent);
export default IconQuestionCircle;